import {TimelineMax, Back, Linear} from 'gsap';
const PIXI = require('pixi.js');
const Shortcuts = require('../utils/Shortcuts');
const MousemoveParallax = require('../utils/MousemoveParallax');


const _addView = instance => {
    const cont = new PIXI.Container();
    const TextureCache = PIXI.utils.TextureCache;
    const sizes = require('../../DefaultProjectSize');

  

    const createCloud = cloudname => {
        return Shortcuts.getCenteredSpriteInCont(cloudname, TextureCache);
    }

    const ygol = new PIXI.Container();
    Shortcuts.addTo(createCloud('l5'), 'yg0', ygol);
    Shortcuts.addTo(createCloud('l3'), 'yg1', ygol);
    Shortcuts.addTo(createCloud('l3'), 'yg2', ygol);
    Shortcuts.addTo(createCloud('l3'), 'yg3', ygol);
    Shortcuts.addTo(createCloud('l3'), 'yg4', ygol);
    Shortcuts.addTo(createCloud('l5'), 'yg5', ygol);
    Shortcuts.addTo(createCloud('l2'), 'yg6', ygol);
    Shortcuts.addTo(createCloud('l1'), 'yg7', ygol);

    const bottom = new PIXI.Container();
    Shortcuts.addTo(createCloud('l3'), 'bbl0', bottom);
    Shortcuts.addTo(createCloud('l3'), 'bbr0', bottom);
    Shortcuts.addTo(createCloud('l3'), 'f0', bottom);
    Shortcuts.addTo(createCloud('l2'), 'f1', bottom);
    Shortcuts.addTo(createCloud('l1'), 'f2', bottom);
    Shortcuts.addTo(createCloud('l3'), 'f3', bottom);
    Shortcuts.addTo(createCloud('l3'), 'c3', bottom);
    Shortcuts.addTo(createCloud('l2'), 'c2', bottom);
    Shortcuts.addTo(createCloud('l1'), 'c1', bottom);
    Shortcuts.addTo(createCloud('l3'), 'c0', bottom);

    const rs = new PIXI.Container();
    Shortcuts.addTo(createCloud('l1'), 'r0', rs);
    Shortcuts.addTo(createCloud('l3'), 'r8', rs);
    Shortcuts.addTo(createCloud('l1'), 'r4', rs);
    Shortcuts.addTo(createCloud('l3'), 'r12', rs);
    Shortcuts.addTo(createCloud('l1'), 'l0', rs);
    Shortcuts.addTo(createCloud('l3'), 'l8', rs);
    Shortcuts.addTo(createCloud('l1'), 'l4', rs);
    Shortcuts.addTo(createCloud('l3'), 'l12', rs);
    Shortcuts.addTo(createCloud('l3'), 'rb0', rs);
    Shortcuts.addTo(createCloud('l1'), 'rb1', rs);
    Shortcuts.addTo(createCloud('l2'), 'lb0', rs);
    Shortcuts.addTo(createCloud('l3'), 'lb1', rs);
    rs.r12.img.scale.x = -1;
    

    const rm = new PIXI.Container();
    Shortcuts.addTo(createCloud('l3'), 'r1', rm);
    Shortcuts.addTo(createCloud('l3'), 'r5', rm);
    Shortcuts.addTo(createCloud('l3'), 'r13', rm);
    Shortcuts.addTo(createCloud('l2'), 'r9', rm);
    Shortcuts.addTo(createCloud('l3'), 'l1', rm);
    Shortcuts.addTo(createCloud('l3'), 'l5', rm);
    Shortcuts.addTo(createCloud('l3'), 'l13', rm);
    Shortcuts.addTo(createCloud('l2'), 'l9', rm);

    const rx = new PIXI.Container();
    Shortcuts.addTo(createCloud('l3'), 'r2', rx);
    Shortcuts.addTo(createCloud('l3'), 'r10', rx);
    Shortcuts.addTo(createCloud('l2'), 'r14', rx);
    Shortcuts.addTo(createCloud('l1'), 'r6', rx);
    Shortcuts.addTo(createCloud('l3'), 'l2', rx);
    Shortcuts.addTo(createCloud('l3'), 'l10', rx);
    Shortcuts.addTo(createCloud('l2'), 'l14', rx);
    Shortcuts.addTo(createCloud('l1'), 'l6', rx);

   
    cont.addChild(rx);
    cont.addChild(rm);
    cont.addChild(rs);
    cont.addChild(bottom);
    cont.addChild(ygol);


    rx.z = 1.3;
    rm.z = 1.4;
    rs.z = 1.6;
    bottom.z = 1.7;
    ygol.z = 1.8;

    ygol.alpha = 1;
    bottom.alpha = 1;
    rs.alpha = 1;
    rm.alpha = 1;
    rx.alpha = 1;


    cont.width = 1000;
    cont.scale.x = cont.scale.y = sizes.width / 3200;

    cont.x = sizes.width / 2;
    

    instance.cont = cont;
    
    instance.width = 3200;
    instance.height = 1800;
    instance.ygol = ygol;
    instance.bottom = bottom;
    instance.rs = rs;
    instance.rm = rm;
    instance.rx = rx;
    instance.parallaxLayers = [ygol, bottom, rs, rm, rx];
       
    instance.root.addChild(cont);
}

const _removeView = instance => {
    if (instance.cont.parent)
        instance.cont.parent.removeChild(instance.cont);
}

const _constructTimeline = instance => {
    const tl = new TimelineMax({paused: true});
    const d1 = 4;
    const d2 = 4;
    const d3 = 1;


    // const tlCloudsRepeat = new TimelineMax({repeat:-1, alpha: 0, ease:Back.easeOut});
    // const tlClouds = new TimelineMax({alpha: 0, ease:Back.easeOut});

    const tlArr = [];

    const __getRad = Shortcuts.getRad;

    tl.set(instance.cont, {alpha: 1}, 'set');

    tl.set(instance.ygol.position, {y: instance.height * 0.8}, 'set');
    tl.set(instance.bottom.position, {y: instance.height * 0.8}, 'set');
    tl.set(instance.rs.position, {y: instance.height * 0.8 - 67}, 'set');
    tl.set(instance.rm.position, {y: instance.height * 0.8}, 'set');
    tl.set(instance.rx.position, {y: instance.height * 0.8}, 'set');
/*
    // IN
    tl.to(instance.ygol, d1, {y: instance.height / 1.2, ease: Linear.easeInOut}, 'in');
    tl.to(instance.bottom, d1, {y: instance.height / 1.2, ease: Linear.easeInOut}, 'in');
    tl.to(instance.rs, d1, {y: instance.height / 1.2, ease: Linear.easeInOut}, 'in');
    tl.to(instance.rm, d1, {y: instance.height / 1.2, ease: Linear.easeInOut}, 'in');
    tl.to(instance.rx, d1, {y: instance.height / 1.2, ease: Linear.easeInOut}, 'in');*/

    // OUT
    tl.to(instance.ygol.position, d2 + d3, {y: -0.47 * instance.height, ease: Linear.easeInOut}, 'set+=' + d1);
    tl.to(instance.bottom.position, d2 + d3, {y: -0.37 * instance.height, ease: Linear.easeInOut}, 'set+=' + d1);
    tl.to(instance.rs.position, d2 + d3, {y: -0.27 * instance.height - 67, ease: Linear.easeInOut}, 'set+=' + d1);
    tl.to(instance.rm.position, d2 + d3, {y: -0.34 * instance.height, ease: Linear.easeInOut}, 'set+=' + d1);
    tl.to(instance.rx.position, d2 + d3, {y: -0.57 * instance.height, ease: Linear.easeInOut}, 'set+=' + d1);

    
    tl.to(instance.cont, d3, {alpha: 0}, 'set+=' + (d1 + d2));




    /* ======================================= */

    const BottomYgol = function (NAME, pause) {
        const timeMov = 15;
        const timeMovAlpha = timeMov / 2;
        const scal = 2;
        
        const tlCloudsRepeat = new TimelineMax({repeat:-1});
        tlArr.push(tlCloudsRepeat);
        tlCloudsRepeat.set(NAME.scale, {x:1, y:1}, 'st');
        tlCloudsRepeat.set(NAME, {alpha:0.4, rotation: 0, x:2750, y:935}, 'st');
        tlCloudsRepeat
            .to(NAME.scale,  timeMov, {x:scal, y:scal}, 'st+=' +  pause)
            .to(NAME,  timeMov, {rotation: __getRad(20),  x:700, y:150}, 'st+=' +  pause)
            .to(NAME,  timeMovAlpha, {alpha:0,   ease:Back.easeOut}, 'st+=' + (timeMovAlpha + pause - 3));
     }

     for (let i = 0; i < instance.ygol.children.length; i++) {
        BottomYgol(instance.ygol['yg' + i], 2 * i);
     }

    /* ======================================= */

    const Start = function (NAME, pause, vertor) { 
        const timeMov = 15; 
        const timeMovAlpha = timeMov / 2;

        const tlClouds = new TimelineMax();
        tlArr.push(tlClouds);
        tlClouds.set(NAME, {alpha:0.5, rotation: 0, x:1200 * vertor, y:-220}, 'st');
        tlClouds
        .to(NAME,  timeMov, {rotation: __getRad(-10) * vertor, x:700 * vertor, y:0}, 'st+=' + pause)
        .to(NAME,  timeMovAlpha, {alpha:0,   ease:Back.easeOut}, 'st+=' + (timeMovAlpha + pause)); 
     
    }
    for (let i = 0; i < 2; i++) {
        Start(instance.rs['lb' + i], 0, -1);
        Start(instance.rs['rb' + i], 0, 1);
     }


    /* ======================================= */    

    const  BottomStart = function (NAME, pause, vertor) {

        const timeMov = 30;
        const timeMovAlpha = timeMov / 2;
        // const scal = Math.floor(Math.random() * (2 - 1.8) + 1.8);
        
        const tlClouds = new TimelineMax();
        tlArr.push(tlClouds);
        tlClouds.set(NAME, {alpha:0.4, rotation: 0, x:-1000 * vertor, y:200}, 'st');
         tlClouds
        .to(NAME,  timeMov, {rotation: __getRad(10 * vertor), x:1200 * vertor, y:200}, 'st+=' + pause)
        .to(NAME,  timeMovAlpha, {alpha:0,   ease:Back.easeOut}, 'st+=' + (timeMovAlpha + pause - 10));  
     
    }
    
    BottomStart(instance.bottom['bbl0'], 0, -1);
    BottomStart(instance.bottom['bbr0'], 0, 1);


    /* ======================================= */ 

    const Bottom = function (NAME, pause, vertor) {
    
        const timeMov = 60; 
        const timeMovAlpha = timeMov / 2;
        // const scal = Math.floor(Math.random() * (2 - 1.8) + 1.8);

        const tlCloudsRepeat = new TimelineMax({repeat:-1});
        tlArr.push(tlCloudsRepeat);       
        tlCloudsRepeat.set(NAME, {alpha:0.4, rotation: 0, x:2750 * vertor, y:200}, 'st');
        tlCloudsRepeat            
            .to(NAME,  timeMov, {rotation: __getRad(10), x:-1200 * vertor, y:200}, 'st+=' + pause)
            .to(NAME,  timeMovAlpha, {alpha:0,   ease:Back.easeOut}, 'st+=' + (timeMovAlpha + pause - 10));  
     
    }

    for (let i = 0; i < 4; i++) {
        Bottom(instance.bottom['c' + i], 15 * i, -1); 
        Bottom(instance.bottom['f' + i], 15 * i, 1); 
     }


    /* ======================================= */ 

    const AllMow = function (NAME, pause, vertor) {
    
        const timeMov = 15;
        const timeMovAlpha = timeMov / 2;
        const scal = 1.9;

        const tlCloudsRepeat = new TimelineMax({repeat:-1});
        tlArr.push(tlCloudsRepeat);    
        tlCloudsRepeat.set(NAME.scale, {x:1, y:1}, 'st');
        tlCloudsRepeat.set(NAME, {alpha:0.4, rotation: 0, x:2750 * vertor, y:-220}, 'st');
        tlCloudsRepeat
            .to(NAME.scale,  timeMov, {x:scal, y:scal}, 'st+=' +  pause)
            .to(NAME,  timeMov, {rotation: __getRad(20 * vertor), x:1600 * vertor, y:0}, 'st+=' +  pause)
            .to(NAME,  timeMovAlpha, {alpha:0,   ease:Back.easeOut}, 'st+=' +  (timeMovAlpha + pause + 3));
    }

    for (let i = 0; i < 16; i++) {
     let j = 0;
    if (j === 0) {
            AllMow(instance.rs['r' + i], 2 * i, 1);
            AllMow(instance.rs['l' + i], 2 * i, -1);
            j = 1;
            i += 1;
        } 
            if (j === 1) {
                AllMow(instance.rm['r' + i], 2 * i, 1);
                AllMow(instance.rm['l' + i], 2 * i, -1);
                j = 2;
                i += 1;
            }
                if (j === 2) {
                    AllMow(instance.rx['r' + i], 2 * i, 1);
                    AllMow(instance.rx['l' + i], 2 * i, -1);
                    j = 0;
                    i += 1;
            }   
    } 

    

    instance.timeline = tl;
    instance.timelines = tlArr;
    return tl;
}

const _destroyTimeline = instance => {
    if (!instance.timelines) return;
    while (instance.timelines.length > 0) {
        instance.timelines.pop().kill();
    }
    instance.timelines = null;
}


function CoverTimelineConstructor(app, root) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;
        const instance = {
            app: app,
            root: root
        };
        _addView(instance);

        constructor.instance = instance;
        _created = true;

        MousemoveParallax.startParallax(instance);
        return _constructTimeline(constructor['instance']);
    };

    constructor.destroy = () => {
        if (!_created) return;

        // Delete all the links
        const instance = constructor['instance'];
        _destroyTimeline(instance);
        Shortcuts.destroyTimeline(instance);
        _removeView(instance);
        MousemoveParallax.stopParallax(instance);
        constructor.instance = null;

        _created = false;
    };

    constructor.startDuration = 4;
    constructor.totalDuration = 9;

    return constructor;
}


module.exports = CoverTimelineConstructor;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/illustrations/FogTimelineConstructor.js